import api from "./interceptor";
import config from "../config";
import { CryptoMethods } from "../utils/crypto-methods";

export const createOrganization = async (payload: Record<string, any>) => {
  try {
    const response = await api.post(
      config.trainingEndPoints.organizations,
      payload
    );
    return response.data.data.organisation;
  } catch (error) {
    return error;
  }
};

export const fetchCadreList = async (search: string) => {
  try {
    const response = await api.get(config.trainingEndPoints.cadre, {
      headers: {
        "X-API-Key": config.xApiKey,
      },
      params: {
        name: search,
        pageSize: 50,
      },
    });
    return response.data.data.cadres;
  } catch (error) {
    return error;
  }
}

export const fetchWorkplaceList = async (search: string) => {
  try {
    const response = await api.get(config.trainingEndPoints.hospital, {
      headers: {
        "X-API-Key": config.xApiKey,
      },
      params: {
        name: search,
        pageSize: 50,
      },
    });
    return response.data.data.hospitals;
  } catch (error) {
    return error;
  }
}

export const addOrganizationAdmins = async (payload: Record<string, any>) => {
  try {
    const response = await api.post(
      config.userEndPoints.orgAdmins,
      payload
    );
    return response.data.data;
  } catch (error) {
    return error;
  }
};

export const fetchOrganizationAdmins = async (code: string) => {
  try {
    const response = await api.get(config.userEndPoints.orgAdmins, {
      params: { code },
    });
    let users = response.data?.data?.users || [];
    users = await Promise.all(
      users.map(async (user: any) => ({
        ...user,
        firstName: await CryptoMethods.ecbDecryptData(user.firstName),
        lastName: await CryptoMethods.ecbDecryptData(user.lastName),
        email: await CryptoMethods.ecbDecryptData(user.email),
      }))
    );
    return users;
  } catch (error) {
    return error;
  }
};

export const fetchOrganizationById = async (id: number) => {
  try {
    const response = await api.get(
      `${config.trainingEndPoints.organizations}/${id}`
    );
    return response?.data?.data?.organisation;
  } catch (error) {
    return error;
  }
};

export const getTrainerExportList = async (
  sessionId: number,
  instanceId?: number,
  searchQuery?: string,
) => {
  try {
    const params: any = { trainingSessionId: sessionId };

    if (instanceId) params.trainingInstanceId = instanceId;
    if (searchQuery) params.searchQuery = searchQuery;

    const response = await api.get(config.trainingEndPoints.trainerExport, {
      params,
    });

    return response.data;
  } catch (error: any) {
    console.error("Error in getTrainerExportList:", error);
    throw error;
  }
};
